<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="industryName1" name="nationalEconomy">
          <nationalEconomy
            v-if="activeName === 'nationalEconomy'"
          ></nationalEconomy>
        </el-tab-pane>
        <el-tab-pane :label="industryName2" name="T565data">
          <T565data v-if="activeName === 'T565data'"></T565data>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import T565data from "./565data";
import nationalEconomy from "./nationalEconomy";
export default {
  components: {
    T565data,
    nationalEconomy,
  },
  data() {
    return {
      activeName: "nationalEconomy",
      industryName1: "",
      industryName2: "",
    };
  },
  created() {
    this.getName();
  },
  methods: {
    getName() {
      this.$axios
        .get("/business/industry/selectByCodeAndName?code=1")
        .then((res) => {
          this.industryName1 = res.data.data[0].name;
        });
      this.$axios
        .get("/business/industry/selectByCodeAndName?code=2")
        .then((res) => {
          this.industryName2 = res.data.data[0].name;
        });
    },
  },
};
</script>
<style>
@import url("../../../assets/styles/elementUI.css");
</style>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>